<!-- 资质情况表 -->

<template>
  <div class="tabCage table4E">
    <div class="tabTtl">
      <span>表 1-4：经营场所情况表</span>
    </div>
    <div class="editArea">
      <el-form ref="paramCk" :model="params" :rules="rules">
        <table>
          <tr>
            <td class="edName">场所情况：</td>
            <td class="edInp edSelect">
              <el-select v-model="params.placeSituation" disabled size="small" placeholder="请选择">
                <el-option v-for="item in dicDats['C002']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
              <el-input
                v-if="dicMap['C002'][params.placeSituation] == '其他'"
                v-model="params.otherSituation"
                disabled
                size="small"></el-input>
            </td>
            <td></td>
          </tr>
          <tr>
            <td class="edName">场所所有权：</td>
            <td class="edInp edSelect">
              <el-select v-model="params.placePower" size="small" disabled placeholder="请选择">
                <el-option v-for="item in dicDats['C020']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
              <el-input
                v-if="dicMap['C020'][params.placePower] == '其他'"
                v-model="params.otherPower"
                size="small"
                disabled></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">面积（平米）：</td>
            <td class="edInp">
              <el-form-item prop="placeArea" :show-message="false">
                <el-input-number
                  v-model="params.placeArea"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  :controls="false"
                  disabled
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">备注：</td>
            <td class="edInpTextArea">
              <el-input type="textarea" :rows="4" v-model="params.remark" disabled size="small"></el-input>
            </td>
          </tr>
        </table>
      </el-form>
    </div>

    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
    </div>
  </div>
</template>

<script>
import { bsParams, paramsRule } from "@/components/LongParams/paramsEt4";
import { tabUpdate4, tabRead4 } from "@/api/pressRole/pressRole";
export default {
  data() {
    return {
      params: bsParams,
      rules: paramsRule,
      submiting: false,
      dicDats: {},
      dicMap: {
        C002: {},
        C020: {},
      },
    };
  },
  methods: {
    dictInit: function () {
      let nameArr = ["C002", "C020"];
      let newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "arr" });
      newPromise.then((result) => {
        this.dicDats = result;
        this.dicMap["C002"] = this.$store.getters.dictionary["C002"];
        this.dicMap["C020"] = this.$store.getters.dictionary["C020"];
      });
    },

    tabReEdit: function () {
      tabRead4({ id: this.$route.query.id }).then((response) => {
        this.params = response.pplace;
      });
    },

    goBack: function () {
      this.$router.go(-1);
    },
  },

  created: function () {
    this.dictInit();
    this.tabReEdit();
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";
</style>



// WEBPACK FOOTER //
// table4.vue?4024649e